// extracted by mini-css-extract-plugin
module.exports = {"line":"TrimmingCoverImage_line__ITE3G","frameLeft":"TrimmingCoverImage_frameLeft__D8CPT","frameRight":"TrimmingCoverImage_frameRight__qJyD9"};